import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {Button, Text, useMultiStyleConfig} from '@chakra-ui/react'
import {GridIconA, GridIconB} from '../../../components/icons'

const GridViewButton = ({gridView, setGridView}) => {
    const styles = useMultiStyleConfig('Filters')
    return (
        <Button
            {...styles.filterButton}
            {...styles.gridViewButtonSpecific}
            data-testid="product-list-grid-view-button"
            onClick={() => setGridView((prevState) => !prevState)}
            leftIcon={
                gridView ? (
                    <GridIconB {...styles.gridViewIcon} />
                ) : (
                    <GridIconA {...styles.gridViewIcon} />
                )
            }
        >
            <Text {...styles.filterText}>
                <FormattedMessage defaultMessage="View" id="product_list.button.view" />
            </Text>
        </Button>
    )
}

GridViewButton.propTypes = {
    gridView: PropTypes.bool,
    setGridView: PropTypes.func,
}
export default GridViewButton
